import { render, staticRenderFns } from "./VxMilestoneProgress.vue?vue&type=template&id=bc6b8ea8&scoped=true"
import script from "./VxMilestoneProgress.vue?vue&type=script&lang=js"
export * from "./VxMilestoneProgress.vue?vue&type=script&lang=js"
import style0 from "./VxMilestoneProgress.vue?vue&type=style&index=0&id=bc6b8ea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b8ea8",
  null
  
)

export default component.exports